<script>
import axios from 'axios'
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import { eventBus } from '@/vcs/_shared/eventBus'

export default {
  extends: BaseModal,
  data: function () {
    return {
      email: '',
      password: ''
    }
  },
  watch: {
    email: function () {
      eventBus.$emit('refresh-token-via-websockets')
    },
    password: function () {
      eventBus.$emit('refresh-token-via-websockets')
    }
  },
  methods: {
    signIn() {
      if (this.email && this.password) {
        this.$blockUI()
        axios({
          method: 'post',
          url: '/auth/sign_in',
          params: {
            email: this.email,
            password: this.password
          }
        })
          .then((response) => {
            if (response.status == 200) {
              this.close(response.data.user)
            }
          })
          .catch((error) => {
            this.$errorHumanized(null, this.$t('unauthorized'))
          })
          .finally(() => {
            this.$unblockUI()
          })
      }
    },
    focusEmail() {
      this.$slideUp()
      eventBus.$emit('refresh-token-via-websockets')
    },
    focusPassword() {
      this.$slideUp()
      eventBus.$emit('refresh-token-via-websockets')
    }
  }
}
</script>

<template lang="pug">
span
  .modal-header
    h4 {{ $t('modals.userSignIdModal.header') }}
  .modal-body
    form(@submit.prevent="signIn")
      .row
        .col-12
          .input-group.mb-3
            label.font-weight-bold Email
            input.form-control(
              type="email"
              v-model="email"
              @focus="focusEmail"
              @blur="$slideDown()"
            )
          .input-group.mb-3
            label.font-weight-bold {{ $t('modals.userSignIdModal.password') }}
            input.form-control(
              type="password"
              v-model="password"
              @focus="focusPassword"
              @blur="$slideDown()"
            )
      button.btn.btn-primary.btn-block(type="submit" @touchend.stop.prevent="signIn") {{ $t('modals.userSignIdModal.signInButton') }}
</template>
